import React from 'react';


function Pagetitle({ children }) {
  return (
    <h1 className="text-center mt-4 mb-5">{children}</h1>
  )
}

export default Pagetitle;